var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'has-tabbar': _vm.showTabBar },attrs:{"id":"app"}},[_c('div',{staticClass:"app-view"},[_c('router-view')],1),(_vm.showTabBar)?_c('tab-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }